import { BaseQueryDTO } from './basequery-dto';

export class QueryAssignmentsForPEDTO extends BaseQueryDTO
{
    PEId: number;
    SourceTypeId: number;
    PartCategoryId: number;
    SupplierCode: string;
    SioCodeId: number | null;
    PartNumber: string;
}

